<template>
<div>
	<div class="tabs">
		<a v-for="tab in tabs" class="tab" :class="{ 'is-active': tab.isActive }" :href="tab.href" @click="selectTab(tab)">{{ tab.name }}</a>
	</div>
	<slot></slot>
</div>
</template>

<script>
export default {
	data() {
		return {
			tabs: []
		};
	},

	created() {
		this.tabs = this.$children;
	},

	methods: {
		selectTab(selectedTab) {
			this.tabs.forEach(tab => {
				tab.isActive = (tab.href == selectedTab.href);
			});
		}
	}
}
</script>
